export var ActionKeys;
(function (ActionKeys) {
    ActionKeys["DOWNLOAD"] = "DOWNLOAD/DOWNLOAD";
    ActionKeys["CREATE_FILE"] = "DOWNLOAD/CREATE_FILE";
    ActionKeys["GET_FILE"] = "DOWNLOAD/GET_FILE";
})(ActionKeys || (ActionKeys = {}));
export const downloadFile = (payload) => ({
    type: ActionKeys.DOWNLOAD,
    payload
});
export const actions = { downloadFile };
//# sourceMappingURL=actions.js.map